import * as config from 'core/config';
import { firebase, request, Store } from 'utils';
import { signIn, signOut } from './';

export const registerFirebaseEvents = () => {
  const store = Store.getInstance();

  firebase.initializeApp(config.firebase);

  firebase.auth().setPersistence(firebase.auth.Auth.Persistence.LOCAL);

  firebase.auth().onAuthStateChanged(async (user) => {
    if (user) {
      store.dispatch(signIn(await user.getIdToken(), user));
    } else {
      store.dispatch(signOut());
    }
  });

  firebase.auth().onIdTokenChanged(async (auth) => {
    const headers = request.defaults.headers.common;
    try {
      if (!auth) {
        throw new Error();
      }
      const idToken = await auth.getIdToken();
      headers.Authorization = `Bearer ${idToken}`;
    } catch (e) {
      delete headers.Authorization;
    }
  });
};
